import { render, staticRenderFns } from "./EditCap.vue?vue&type=template&id=0031d163&"
import script from "./EditCap.vue?vue&type=script&lang=js&"
export * from "./EditCap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports